<iframe #iframe title="Voc Form" [hidden]="loadingTemplate" [src]="url | safeHtml: 'resourceUrl'" class="frame-container"></iframe>

<ng-container *ngIf="loadingTemplate">
    <div class="spinner d-flex justify-content-center align-items-center frame-container">
        <lib-spinner></lib-spinner>
    </div>
</ng-container>
